var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20.801,
    viewBox: "0 0 27.286 20.801",
    width: 27.286,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m1038.458 929.191 6.349-6.349h6.675l-8.8 8.8h-4.226zm19.769-6.349h3.939v2.449l-6.349 6.349h-6.389zm-.609-4.548v2.759h-14.612v-2.759h-1.789v2.759h-4.548v12.376h4.548v5.665h1.789v-5.665h14.612v5.665h1.789v-5.665h4.548v-12.377h-4.548v-2.759z",
    transform: "translate(-1036.669 -918.293)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1036.669 -918.293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1038.458 929.191 6.349-6.349h6.675l-8.8 8.8h-4.226zm19.769-6.349h3.939v2.449l-6.349 6.349h-6.389zm-.609-4.548v2.759h-14.612v-2.759h-1.789v2.759h-4.548v12.376h4.548v5.665h1.789v-5.665h14.612v5.665h1.789v-5.665h4.548v-12.377h-4.548v-2.759z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "translate(1036.669 918.293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h44.341v37.855h-44.341z",
    fill: "#fff",
    transform: "translate(-8.527 -8.526)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefects);
export default __webpack_public_path__ + "static/media/defects.cdb58d663b4237e49f832c7f32f6dbd7.svg";
export { ForwardRef as ReactComponent };